/**
 * Merges a saved column order into the live, declared column order. A saved order is usually partial
 * (a freshly added column has no saved entry), so this applies it only to the slots its listed ids
 * already occupy — an id with no saved entry keeps its declared position rather than being pushed to
 * the end. Any caller building its own column order (e.g. a CSV export) must use this, not a simpler
 * "saved ids first, then the rest" merge, or its order will drift from what the table shows.
 */
export function mergeColumnOrder(liveIds: string[], frozenIds: string[], savedOrder: string[]): string[] {
	const liveIdSet = new Set(liveIds)
	const savedIds = savedOrder.filter(id => liveIdSet.has(id))
	if (savedIds.length === 0) {
		return [...frozenIds, ...liveIds]
	}
	const queue = [...savedIds]
	const savedSet = new Set(savedIds)
	const merged = liveIds.map(id => (savedSet.has(id) ? (queue.shift() as string) : id))
	return [...frozenIds, ...merged]
}
